import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	errMsg;
	errSubMsg;
	showRefresh;
	showLogout;
	errorStatus: any;
	errorStatus$: Subscription = Subscription.EMPTY;

	/** show Offline Ui behavior subject */
	checkForError = new BehaviorSubject(false);
	/** show Offline Ui observable */
	checkForError$ = this.checkForError.asObservable();

	/** hide sidemenu behavior subject */
	hideSidemenuFlag = new BehaviorSubject(false);
	/** hide sidemenu observable */
	hideSidemenuFlag$ = this.hideSidemenuFlag.asObservable();

	handleServerError(type, message, subMsg, refreshFlag, logoutFlag) {
		this.errMsg = message;
		this.errSubMsg = subMsg;

		if (type === environment.ERROR_TYPE.SERVERERROR && refreshFlag === true) {
			this.showRefresh = refreshFlag;
		} else if (
			(type === environment.ERROR_TYPE.UNAUTHORIZED && logoutFlag === true) ||
			(type === environment.ERROR_TYPE.FORBIDDEN && logoutFlag === true)
		) {
			this.showLogout = logoutFlag;
		}

		this.checkForError.next(true);
	}
}
